module.exports = __webpack_public_path__ + "static/media/infor.3becbd0d.png";